import React from "react";

import LogoIcon from "../../assets/images/Logo.svg";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export default function Logo({ className = "", style }: Props) {
  return (
    <img
      src={LogoIcon}
      alt="Braskem logo"
      className={className}
      style={style}
    />
  );
}
